import { useSearchParams } from 'react-router-dom'
import { useMutation } from 'react-query'
import { userService } from 'src/services/user.service'

const useVerifyChangeUserPassword = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const token = searchParams.get('change_password_token')
  return useMutation(
    async (code: string) => {
      if (!token) return null
      return userService.verifyChangePassword(token, code)
    },
    {
      onSettled(data) {
        if (data) {
          searchParams.delete('change_password_token')
          setSearchParams(searchParams)
        }
      },
    },
  )
}

export { useVerifyChangeUserPassword }
